export const TERMS_AND_CONDITIONS_TAG_NAME = 'terms-and-conditions';
